import React, { useEffect, useContext, useState, Suspense, lazy } from "react";

import { useParams, useLocation, Link } from "react-router-dom";

import {
  Container,
  Grid,
  Tooltip,
  Menu,
  MenuItem,
  FormGroup,
  FormControlLabel,
  Switch,
  Button,
  useMediaQuery,
  Hidden,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
//import { Skeleton } from "@material-ui/lab";

import { EqualHeight } from "react-equal-height";

import InView from "../misc/InView";

import PlayCard from "./cards/PlayCard";
import SongFavorite from "./parts/SongFavorite";

import CustomizeStation from "./modals/CustomizeStation";

const BanMessage = lazy(
  () => import(/* webpackChunkName: "bnmssg" */ "./parts/BanMessage"),
);
const TuneInMessage = lazy(
  () => import(/* webpackChunkName: "timssg" */ "./parts/TuneInMessage"),
);
const SongRadioMessage = lazy(
  () => import(/* webpackChunkName: "srmssg" */ "./parts/SongRadioMessage"),
);
const PlayerSettings = lazy(
  () => import(/* webpackChunkName: "plysttngs" */ "./parts/PlayerSettings"),
);
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";
import { playerStoreContext } from "lib/player_store";

import PlayerMainRow from "../player/PLayerMainRow";
//import * as Vibrant from "node-vibrant";
import { extractColors } from "extract-colors";

import { v4 as uuidv4 } from "uuid";

import { tunein } from "lib/player_util";
import { disableScroll, enableScroll } from "lib/util";

import { postJSON } from "lib/ajax";

const NowPlaying = observer(({ skip }) => {
  const { artist: pageArtist } = useParams();
  const location = useLocation();
  const theme = useTheme();
  const mediumDown = useMediaQuery(theme.breakpoints.down("sm"));

  const store = useContext(playerStoreContext);

  const {
    songInfo: { _song, similar_stations, artist },
    firstLoad,
    landingPathname,
  } = store;

  useEffect(() => {
    console.log("NowPlaying onMount");
    return () => {
      console.log("NowPlaying onUnmount");
    };
  }, []);

  // const getPalette = (imgSrc) => {
  //   return Vibrant.from(imgSrc)
  //     .getPalette()
  //     .then((palette) => {
  //       store.set_albumArtPalette({
  //         light: palette.LightMuted.rgb.map((x) => parseInt(x, 10)),
  //         dark: palette.Muted.rgb.map((x) => parseInt(x, 10)),
  //       });
  //     });
  // };

  // hide if visiting an artist page that is not playing
  // support landing on an artist page and playing that artist with <NowPlaying> visible
  // console.log(
  //   "pageArtist",
  //   pageArtist,
  //   artist,
  //   "location.pathname",
  //   location.pathname,
  //   "landingPathname",
  //   landingPathname
  // );
  if (
    !firstLoad &&
    landingPathname !== location.pathname &&
    location.pathname !== "/"
  ) {
    console.log("NowPlaying returning blank");
    return "";
  }

  return (
    <PlayerMainRow>
      <div
        id="now-playing"
        className="dark-bg container-standard"
        style={{ minHeight: "350px" }}
      >
        <Container>
          <Grid
            container
            className="align-items-md-center"
            alignItems="baseline"
          >
            <Grid item xs={12} sm={4} md={3} lg={true}>
              <AlbumArt />
              <Hidden only="sm">
                <NowPlayingSong skip={skip} />
              </Hidden>
            </Grid>

            <Grid
              item
              xs={12}
              sm={8}
              md={6}
              style={{ alignSelf: mediumDown ? "flex-start" : "inherit" }}
              className={`currentStation-${mediumDown ? "xs" : "md"}`}
            >
              <CurrentStation skip={skip} />
            </Grid>
            <Hidden only={["xs", "md", "lg", "xl"]}>
              <Grid item xs={12} md={3}>
                <NowPlayingSong skip={skip} />
              </Grid>
            </Hidden>
            <Grid item xs={12} md={3} lg={true}>
              <InView>
                <RelatedStations stations={similar_stations} />
              </InView>
            </Grid>
          </Grid>
        </Container>
      </div>
    </PlayerMainRow>
  );
});

const AlbumArt = observer(() => {
  const store = useContext(playerStoreContext);

  const {
    songInfo: { album_art, album_art_srcset },
  } = store;

  const setPlayerBG = (event) => {
    extractColors(event.currentTarget, {
      pixels: 50,
      colorValidator: (red, green, blue, alpha = 255) =>
        red < 230 &&
        green < 230 &&
        blue < 230 &&
        red > 20 &&
        green > 20 &&
        blue > 20,
    })
      .then((palette) => {
        let sp = palette; //.sort((a,b) => b.lightness - a.lightness)
        let c1 = sp[0];
        let c2 = sp[sp.length - 1];
        store.set_albumArtPalette({
          light: [c1.red, c1.green, c1.blue].map((x) => parseInt(x, 10)),
          dark: [c2.red, c2.green, c2.blue].map((x) => parseInt(x, 10)),
        });
      })
      .catch((error) => {
        console.log("extract colors error:", error);
      });
  };

  return (
    <div>
      {/* i=1 to defeat cache for error: origin https://www.jango.com is not allowed by Access-Control-Allow-Origin */}

      <img
        fetchpriority="high"
        onLoad={setPlayerBG}
        src={album_art}
        srcSet={album_art_srcset}
        className="main-image"
        crossOrigin="anonymous"
      />
    </div>
  );
});

const NowPlayingSong = observer(({ skip }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [banMessageOpen, setBanMessageOpen] = useState(false);
  const [tuneinSnackOpen, setTuneinSnackOpen] = useState(false);
  const [songRadioSnackOpen, setSongRadioSnackOpen] = useState(false);

  const store = useContext(playerStoreContext);

  const {
    songInfo: {
      song,
      artist,
      song_id,
      favorite,
      has_radio,
      station_id,
      artist_station_id,
      station_name,
    },
    user_id,
  } = store;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    disableScroll();
  };

  const handleClose = () => {
    setAnchorEl(null);
    enableScroll();
  };

  const handleSongFavorite = () => {
    postJSON({
      url: "/song_ratings/add_favorite",
      data: {
        song_id: song_id,
      },
    }).then(() => {
      store.setSongFavorite(true);
      faveMessage();
    });
    handleClose();
  };

  const faveMessage = ({ isFavorite, _song_id }) => {
    if (isFavorite) {
      store.setFaveSnackOpen(true);
    }
  };

  const handleSongBan = () => {
    postJSON({
      url: "/song_ratings/add_ban",
      data: {
        song_id: song_id,
      },
    }).then(() => {
      store.setSongFavorite(false);
    });
    setBanMessageOpen(true);
    setTimeout(() => {
      skip();
    }, 2000);
    handleClose();
  };

  const song_radio_tunein = (e) => {
    e?.preventDefault();
    setSongRadioSnackOpen(true);

    return tunein(null, null, null, song_id, true);
  };

  const artist_radio_tunein = (e) => {
    e?.preventDefault();
    setTuneinSnackOpen(true);
    return tunein(artist_station_id, null, null, null, true);
  };

  return (
    <div>
      <Grid container className="align-items-center pt-2">
        <Grid item id="now-playing-heart" className="pr-4 pl-2">
          <SongFavorite
            song_id={song_id}
            favorite={favorite}
            callback={faveMessage}
          />
        </Grid>
        <Grid item xs>
          <h3 className="player-heading">Now Playing</h3>
          <p>
            {has_radio ? (
              <Tooltip title={`Launch '${song}' Radio`}>
                <span className="click-underline" onClick={song_radio_tunein}>
                  {song}
                </span>
              </Tooltip>
            ) : (
              <strong>{song}</strong>
            )}
            &nbsp;&nbsp;by&nbsp;&nbsp;
            {station_id == artist_station_id ? (
              <strong>{artist}</strong>
            ) : (
              <Tooltip title={`Launch ${artist} Radio`}>
                <span className="click-underline" onClick={artist_radio_tunein}>
                  {artist}
                </span>
              </Tooltip>
            )}
          </p>
        </Grid>
        <Grid
          item
          id="now-playing-ellipsis"
          className="pr-2 pl-2 pl-sm-4"
          aria-controls="now-playing-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          <FontAwesomeIcon icon="ellipsis-v" className="icon-action" />
        </Grid>
      </Grid>
      <Menu
        disableScrollLock={true}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleSongFavorite}>Add song to favorites</MenuItem>
        <MenuItem onClick={handleSongBan}>Don't play again</MenuItem>
      </Menu>
      <Suspense fallback={null}>
        {banMessageOpen && (
          <BanMessage open={banMessageOpen} setOpen={setBanMessageOpen} />
        )}
      </Suspense>
      <Suspense fallback={null}>
        {tuneinSnackOpen && (
          <TuneInMessage
            open={tuneinSnackOpen}
            setOpen={setTuneinSnackOpen}
            station_name={station_name}
          />
        )}
      </Suspense>
      <Suspense fallback={null}>
        {songRadioSnackOpen && (
          <SongRadioMessage
            open={songRadioSnackOpen}
            setOpen={setSongRadioSnackOpen}
            song_id={song_id}
            station_name={station_name}
            user_id={user_id}
          />
        )}
      </Suspense>
    </div>
  );
});

const CurrentStation = observer(({ skip }) => {
  const store = useContext(playerStoreContext);

  const {
    user_id,
    songInfo: {
      station_type,
      station_name,
      artist_id,
      song_id,
      station_id,
      oid,
      oname,
    },
  } = store;

  return (
    <div className="p-2 pl-sm-4" id="current-station">
      <Grid container alignItems="center">
        <Grid item className="pr-md-4" xs>
          <h3 className="player-heading d-inline-block">Current Station</h3>
          <CustomizeStation
            station_type={station_type}
            is_owner={
              oid == user_id || (user_id == 0 && station_id.length == 32)
            }
            station_id={station_id}
            user_id={user_id}
            skip={skip}
          />
          <h1 className="m-0">
            <Link to={`/stations/${station_id}`}>
              {station_name}
              {oname && (
                <div style={{ fontSize: "0.9rem", fontFamily: "Roboto" }}>
                  Curated by {oname}
                </div>
              )}
            </Link>
          </h1>
        </Grid>
      </Grid>

      <Hidden only="xs">
        <div className="mt-4">
          <Suspense fallback={null}>
            <PlayerSettings skip={skip} />
          </Suspense>
        </div>
      </Hidden>
    </div>
  );
});

// const GlobalStyle = createGlobalStyle`
//   #now-playing .card {
//   background-color: ${(props) => `rgb(${props.light.toString()})`};
//   :hover{ background-color: ${(props) => `rgb(${props.dark.toString()})`};
//   }
// `;

const RelatedStations = ({ stations }) => {
  // const store = useContext(playerStoreContext);
  // const {
  //   albumArtPalette: { light, dark },
  // } = store;

  return (
    <div id="related-stations">
      {/*      <GlobalStyle light={toJS(light)} dark={toJS(dark)} />
       */}{" "}
      <h3 className="mt-md-0 player-heading">Explore Stations</h3>
      <p className="player-subheading">
        Our picks for you based on your listening:
      </p>
      <EqualHeight>
        <Grid container className="card-container pt-2 pb-2" spacing={2}>
          {stations?.map(({ id, name, art }) => {
            return (
              <Grid key={uuidv4()} item xs={6} sm={3} md={6}>
                <PlayCard title={name} image={art} station_id={id} />
              </Grid>
            );
          })}
        </Grid>
      </EqualHeight>
    </div>
  );
};

export default NowPlaying;
